import styled from 'styled-components';
import addAlpha from 'utils/addAlpha';
import { ellipsis } from 'polished';
import DefaultActionButton from 'components/Buttons/ActionButton';
import { Body, CircledNumber } from 'components/Typography';
import DefaultSelectAdd from 'components/Form/SelectAdd';

export const SelectAdd = styled(DefaultSelectAdd)``;

export const Placeholder = styled(Body)`
  font-weight: 600;
  width: 100%;
  text-align: center;
  padding: 1rem 0;
`;

export const ItemCard = styled.div`
  border: 0.0625rem solid ${({ theme }) => theme.colors.gray2};
  border-radius: 1rem;

  :not(:last-child) {
    margin-bottom: 2rem;
  }
`;

// TODO: TFR-45:Header make unique name or do not export
export const Header = styled.div`
  border-bottom: 0.0625rem solid ${({ theme }) => theme.colors.gray2};
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 1.1875rem 0 0.75rem 1rem;
`;

// TODO: TFR-45:Name make unique name or do not export
export const Name = styled(Body)`
  font-weight: 700;
  margin-bottom: 0.5rem;
`;

// TODO: TFR-44 move to typography group
export const Choices = styled(Body)`
  span {
    color: ${({ theme }) => addAlpha(theme.colors.navyGreen, 0.6)};
  }
`;

// TODO: TFR-44 move to button group
export const ActionButton = styled(DefaultActionButton)`
  border: none;
  color: ${({ theme }) => addAlpha(theme.colors.navyGreen, 0.6)};
`;

// TODO: TFR-44 move to container group
export const Footer = styled.div`
  padding: 1rem;
`;

// TODO: TFR-44 move to container group
export const ItemRow = styled.div`
  display: grid;
  grid-template-columns: minmax(0, 1fr) minmax(0, 1fr);

  :not(:last-child) {
    margin-bottom: 0.75rem;
  }
`;

// TODO: TFR-44 move to container group
export const BlockLeft = styled.div`
  flex: 1;
  display: flex;
`;

// TODO: TFR-44 move to container group
export const BlockRight = styled.div`
  flex: 1;
  display: flex;
  justify-content: space-between;
`;

// TODO: TFR-44 move to typography or containers group
export const Number = styled(CircledNumber)`
  margin-right: 0.75rem;
`;

// TODO: TFR-44 move to typography group
export const ItemName = styled(Body)`
  font-weight: 600;
  ${ellipsis('100%')}
`;

// TODO: TFR-44 move to typography group
export const ItemStatus = styled(Body)`
  color: ${({ theme }) => addAlpha(theme.colors.navyGreen, 0.6)};
`;

// TODO: TFR-44 move to typography group
export const ItemPrice = styled(Body)`
  color: ${({ theme }) => addAlpha(theme.colors.navyGreen, 0.8)};
`;
